/**
 * A2UI Slider Component
 * Range slider with data binding
 */

import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const A2UISlider = ({ 
  label,
  value,
  dataBinding,
  min = 0,
  max = 100,
  step = 1,
  showValue = true,
  disabled = false,
  action,
  style,
  resolveValue,
  onDataChange,
  onAction,
  surfaceId,
  componentId
}) => {
  const resolvedLabel = resolveValue ? resolveValue(label, surfaceId) : label?.literalString || '';
  const resolvedValue = resolveValue ? resolveValue(value || dataBinding, surfaceId) : min;
  const resolvedDisabled = resolveValue ? resolveValue(disabled, surfaceId) : disabled?.literalBoolean || false;
  
  const [localValue, setLocalValue] = useState(resolvedValue || min);

  useEffect(() => {
    setLocalValue(resolvedValue || min);
  }, [resolvedValue, min]);

  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setLocalValue(newValue);
    
    if (dataBinding?.path && onDataChange) {
      onDataChange(surfaceId, dataBinding.path, newValue);
    }
  };

  const handleMouseUp = () => {
    if (action && onAction) {
      onAction({
        name: action.name,
        surfaceId,
        sourceComponentId: componentId,
        context: action.context,
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <Form.Group className="a2ui-slider mb-3" style={style}>
      {resolvedLabel && (
        <Form.Label>
          {resolvedLabel}
          {showValue && <span className="ms-2 text-muted">({localValue})</span>}
        </Form.Label>
      )}
      <Form.Range
        value={localValue}
        onChange={handleChange}
        onMouseUp={handleMouseUp}
        onTouchEnd={handleMouseUp}
        disabled={resolvedDisabled}
        min={min}
        max={max}
        step={step}
      />
    </Form.Group>
  );
};

export default A2UISlider;
